// La financiera de una venta y cómo se rotula. Compartida por Vendedores y Tiendas: las dos leen
// el mismo listado de ventas y tenían que resolver el proveedor de la misma forma.
//
// Las SIGLAS (`SK` · `PJ` · …) NO viven acá: cada pantalla usa las de su propio mockup y hoy no
// coinciden entre sí. Unificarlas es decisión de producto.
import type { Financier } from '@/api/services/retail-org/backoffice';
import type { BackofficeSale } from '@/api/services/retail-wizard/contract';

/** Nombre comercial de la financiera, calcado del `labelMap` del mockup de Tiendas. */
export const FINANCIER_LABEL: Record<Financier, string> = {
    SUREKEEP: 'SureKeep',
    PAYJOY: 'PayJoy',
    CREDIYA: 'CrediYa',
    LESPAGO: 'LesPago',
    INNOVA: 'Innova',
    CASH: 'Contado',
};

/**
 * La financiera de una venta. `externalProvider` solo existe para terceros, así que el crédito
 * propio (`CREDIT` sin proveedor) resuelve a SureKeep. Un tipo desconocido devuelve `null`: la fila
 * pinta un guion en vez de afirmar "contado".
 */
export function financierOfSale(
    sale: Pick<BackofficeSale, 'type' | 'externalProvider'>,
): Financier | null {
    const provider = sale.externalProvider;
    if (provider !== null && provider in FINANCIER_LABEL) return provider as Financier;
    if (sale.type === 'CREDIT') return 'SUREKEEP';
    if (sale.type === 'CASH') return 'CASH';
    return null;
}
